export function isTrainFeatureEnabled(userState) {
    if (!userState) {
        return false;
    }
    return (userState.credentialing.featureFlags.some((flag) => flag === 'trainIntegration') &&
        userState.credentialing.featureFlags.includes('licenseCheck'));
}
